import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { http, formatApiError } from "@/lib/api";
import { useAuth } from "@/lib/auth";

export default function ResetPasswordPage() {
    const [params] = useSearchParams();
    const token = params.get("token") || "";
    const [pw, setPw] = useState("");
    const [pw2, setPw2] = useState("");
    const [busy, setBusy] = useState(false);
    const navigate = useNavigate();
    const { refresh } = useAuth();

    const submit = async (e) => {
        e.preventDefault();
        if (pw !== pw2) {
            toast.error("Les deux mots de passe ne sont pas identiques.");
            return;
        }
        setBusy(true);
        try {
            await http.post("/auth/reset-password", { token, password: pw });
            await refresh();
            toast.success("Mot de passe enregistré. Vous êtes connecté·e.");
            navigate("/espace");
        } catch (err) {
            const detail = err?.response?.data?.detail;
            toast.error(typeof detail === "string" ? detail : formatApiError(err));
        } finally {
            setBusy(false);
        }
    };

    return (
        <div className="min-h-[80vh] flex items-center justify-center px-6 py-16" data-testid="reset-password-page">
            <div className="w-full max-w-md">
                <div className="text-sm tracking-[0.25em] uppercase text-primary mb-4 font-medium">Nouveau mot de passe</div>
                <h1 className="font-serif text-4xl sm:text-5xl mb-8">Choisir un nouveau mot de passe</h1>
                {!token ? (
                    <p className="text-foreground/70" data-testid="reset-password-missing-token">
                        Ce lien est incomplet. <Link to="/mot-de-passe-oublie" className="text-primary underline">Demandez un nouveau lien</Link>.
                    </p>
                ) : (
                    <form onSubmit={submit} className="space-y-6">
                        <div>
                            <Label htmlFor="pw" className="mb-2 block">Nouveau mot de passe (6 caractères minimum)</Label>
                            <Input id="pw" type="password" required minLength={6} value={pw} onChange={(e) => setPw(e.target.value)} className="h-12 rounded-full" data-testid="reset-password-input" />
                        </div>
                        <div>
                            <Label htmlFor="pw2" className="mb-2 block">Confirmer le mot de passe</Label>
                            <Input id="pw2" type="password" required minLength={6} value={pw2} onChange={(e) => setPw2(e.target.value)} className="h-12 rounded-full" data-testid="reset-password-confirm" />
                        </div>
                        <Button type="submit" disabled={busy} className="w-full h-12 rounded-full" data-testid="reset-password-submit">
                            {busy ? "Enregistrement…" : "Enregistrer mon mot de passe"}
                        </Button>
                        <p className="text-sm text-center">
                            <Link to="/mot-de-passe-oublie" className="text-muted-foreground underline underline-offset-4" data-testid="reset-request-new">Lien expiré ? Demander un nouveau lien</Link>
                        </p>
                    </form>
                )}
            </div>
        </div>
    );
}
